(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/syndicate-no-permission.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/syndicate-no-permission.js');

'use strict';

function syndicateNoPermission(_ref) {
  let syndicateName = _ref.syndicateName,
    cancel = _ref.cancel;
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    allowDimmerClick: true,
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: "Du kan inte f\xF6rl\xE4nga spel i ".concat(syndicateName),
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Lagledaren styr vem som kan lägga och annullera spela i laget.'
    }],
    actions: [{
      title: 'OK',
      callback() {
        dialog.close();
        cancel();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
}
svs.numbergames.pay_numbergames.syndicateNoPermission = syndicateNoPermission;

 })(window);